"use client";

import { useTranslations } from "next-intl";

export default function WhatIsSurfaceFinishing() {
	const t = useTranslations("new-surface-finishing");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-center lg:gap-14">
					<div>
						<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
							{t("whatIsTitle")}
						</h2>
					</div>

					<p className="text-sm leading-relaxed text-black md:text-base">{t("whatIsDesc")}</p>
				</div>
			</div>
		</section>
	);
}
